module.exports = {
  "country": "NL",
  "artist": "Teach - In",
  "song": "Ding-A-Dong",
  "year": "1975",
  "place": "1",
  "spotify": "3ML1JVicjXbdsyYrPdfr5E"
};